module.exports = __webpack_public_path__ + "a5534c103d2181add80384a4a3d03078.ttf";